import { useState } from "react"
export const usePageChange = (defaultPage: number) => {
  const [page, setPage] = useState(defaultPage)

  const handleChangePage = (page: number) => {
    //const convertedResult = numberConverter(page)
    if (!page) {
      setPage(1)
      return
    }
    setPage(page)
  }

  return { page, handleChangePage }
}

//const numberConverter = (input: string) => parseInt(input) || 1
